<template>
  <el-row style="padding: 50px 50px 30px 50px;" v-loading.body="fetchLoding">
    <!-- 基本信息 -->
    <el-form :model="merchandiseData" :rules="rules" label-width="130px" ref="ruleForm">
      <el-card class="box-card">
        <!-- 基本商品信息 -->
        <div>
          <h4>{{generateCustomizeString('basicInformation')}}</h4>
          <p style="padding-left: 120px; font-size: 14px; color: red;">
            {{ generateCustomizeString('compulsory') }}
          </p>
          <el-form-item :label="generateCustomizeString('mobileURL')" v-if="!isCreate">
            <el-tag style="font-size: 12px;">
              <a :href="mobileUrl + '/product/detail/' + this.merchandiseData.id" target="_blank">
                <span>{{ mobileUrl + '/product/detail/' + this.merchandiseData.id }}</span>
              </a>
            </el-tag>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('pcURL')" v-if="!isCreate">
            <el-tag style="font-size: 12px;">
              <a :href="pcUrl + '/product/detail/' + this.merchandiseData.id" target="_blank">
                <span>{{ pcUrl + '/product/detail/' + this.merchandiseData.id }}</span>
              </a>
            </el-tag>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('productName')" prop="product_name">
            <el-input
              v-model="merchandiseData.product_name"
              :placeholder="generateCustomizeString('productName')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('productSubtitle')" prop="product_subtitle">
            <el-input
              v-model="merchandiseData.product_subtitle"
              :placeholder="generateCustomizeString('productSubtitle')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="generateCustomizeString('productAbbreviation')"
            prop="product_abbreviation"
          >
            <el-input
              v-model="merchandiseData.product_abbreviation"
              :placeholder="generateCustomizeString('productAbbreviation')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('selectedCategories')" prop="category_id">
            <el-cascader
              expand-trigger="hover"
              :options="categoriesOptions"
              v-model="selectedCategories"
              :placeholder="generateCustomizeString('selectedCategories')"
              @change="handleChangeCategory"
              change-on-select
            ></el-cascader>
            <el-button
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="fetchCategories"
            >{{generateCustomizeString('refresh')}}</el-button>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('productBrand')" prop="brand_id">
            <el-select
              v-model="merchandiseData.brand_id"
              filterable
              :placeholder="generateCustomizeString('productBrand')"
            >
              <el-option
                v-for="item in brandOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="fetchBrand"
            >{{generateCustomizeString('refresh')}}</el-button>
            <el-button
              v-if="isCreate"
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="$router.push({ name: 'CreateBrand' })"
            >{{generateCustomizeString('createBrand')}}</el-button>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('shippingWarehouse')" prop="warehouse_id">
            <span class="none-font" v-show="warehouseOptions.length==0">{{generateCustomizeString('noData')}}</span>
            <el-radio-group v-model="merchandiseData.warehouse_id">
              <el-radio-button
                v-for="item in warehouseOptions"
                :key="item.value"
                :label="item.value"
              >{{item.label}}</el-radio-button>
            </el-radio-group>
            <el-button
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="fetchWarehouse"
            >{{generateCustomizeString('refresh')}}</el-button>
            <el-button
              v-if="isCreate"
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="$router.push({ name: 'CreateWarehouse' })"
            >{{generateCustomizeString('createWarehouse')}}</el-button>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('discountPlan')" prop="discount_plan_id">
            <span class="none-font" v-show="discountPlanOptions.length==0">{{generateCustomizeString('noData')}}</span>
            <el-radio-group v-model="merchandiseData.discount_plan_id" style="margin-top: -10px;">
              <el-radio
                v-for="item in discountPlanOptions"
                :key="item.value"
                :label="item.value"
                border
                style="margin-top: 10px;"
              >{{item.label}}</el-radio>
            </el-radio-group>
            <el-button
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="fetchDiscountPlan"
            >{{generateCustomizeString('refresh')}}</el-button>
            <el-button
              v-if="isCreate"
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="$router.push({ name: 'DiscountPlanList' })"
            >{{generateCustomizeString('createDiscountPlan')}}</el-button>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('expressType')" prop="express_type">
            <el-radio-group v-model="merchandiseData.express_type">
              <el-radio-button
                v-for="item in expressTypeOptions"
                :key="item.value"
                :label="item.value"
              >{{item.label}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="generateCustomizeString('expressTemplate')"
            prop="express_template_id"
          >
            <span class="none-font" v-show="expressTemplateOptions.length==0">{{generateCustomizeString('noData')}}</span>
            <el-radio-group v-model="merchandiseData.express_template_id">
              <el-radio
                v-for="item in expressTemplateOptions"
                :key="item.value"
                :label="item.value"
                border
              >{{item.label}}</el-radio>
            </el-radio-group>
            <el-button
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="fetchExpressTemplate"
            >{{generateCustomizeString('refresh')}}</el-button>
            <el-button
              v-if="isCreate"
              type="info"
              size="small"
              round
              style="margin-left: 10px;"
              @click="$router.push({ name: 'CreateTemplate' })"
            >{{generateCustomizeString('createTemplate')}}</el-button>
          </el-form-item>
          <el-form-item
            :label="generateCustomizeString('bestUseBefore')"
            prop="best_use_before_at"
            style="font-size: 14px; color: #606266;"
          >
            <el-date-picker
              v-model="merchandiseData.best_use_before_at"
              type="month"
              value-format="yyyy-MM-dd"
              :placeholder="generateCustomizeString('chooseShelfLife')"
              editable
            ></el-date-picker>
            <span style="margin-left: 10px;">{{generateCustomizeString('optionShelifLife')}}</span>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('keyword')" prop="key_word">
            <el-input
              v-model="merchandiseData.key_word"
              :placeholder="generateCustomizeString('keyword')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('defaultSales')" prop="origin_sales_volume">
            <el-input
              v-model="merchandiseData.origin_sales_volume"
              :placeholder="generateCustomizeString('defaultSales')"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('defaultViews')" prop="origin_views">
            <el-input
              v-model="merchandiseData.origin_views"
              :placeholder="generateCustomizeString('defaultViews')"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              type="number"
            ></el-input>
          </el-form-item>
          <div v-if="!isCreate">
            <el-form-item :label="generateCustomizeString('actualSales')">
              <el-input v-model=" merchandiseData.real_sales_volume" disabled type="number"></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('actualViews')">
              <el-input v-model="merchandiseData.real_views" disabled type="number"></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('displaySales')">
              <el-input v-model="displaySalesVolume" disabled type="number"></el-input>
            </el-form-item>
            <el-form-item :label="generateCustomizeString('displayViews')">
              <el-input v-model="displayViews" disabled type="number"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 30px;">
        <div style="padding: 10px 0px 10px 0px;" class="clearfix">
          <!-- 商品属性 start-->
          <h4>{{generateCustomizeString('merchandiseAttributes')}}</h4>
          <div>
            <el-col :span="12" style="position:relative;">
              <el-form-item :label="generateCustomizeString('productSPUWeight')" prop="weight">
                <el-input
                  v-model="merchandiseData.weight"
                  :placeholder="generateCustomizeString('productSPUWeight')"
                  style="width: 240px;"
                  min="0"
                  type="number"
                  step="1"
                >
                  <template slot="append">g</template>
                </el-input>
              </el-form-item>
              <div
                class="spu-notice"
                style="position: absolute;left:140px; bottom:3px; color: red; font-size: .8rem;"
              >
                <span>{{ generateCustomizeString('SpuWeightNotice') }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="generateCustomizeString('productLength')" prop="length">
                <el-input
                  v-model="merchandiseData.length"
                  :placeholder="generateCustomizeString('productLength')"
                  style="width: 240px;"
                  min="0"
                  type="number"
                  step="1"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="generateCustomizeString('productWidth')" prop="width">
                <el-input
                  v-model="merchandiseData.width"
                  :placeholder="generateCustomizeString('productWidth')"
                  style="width: 240px;"
                  min="0"
                  type="number"
                  step="1"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="generateCustomizeString('productHeight')" prop="height">
                <el-input
                  v-model="merchandiseData.height"
                  :placeholder="generateCustomizeString('productHeight')"
                  style="width: 240px;"
                  min="0"
                  type="number"
                  step="1"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
          </div>
          <!-- 商品属性 end-->

          <!-- 单个Sku start -->
          <div v-if="singleSku">
            <el-col :span="24">
              <el-form-item :label="generateCustomizeString('priceSoldNz')">
                <el-input
                  v-model="merchandiseData.skus[0].price"
                  :placeholder="generateCustomizeString('priceSoldNz')"
                  type="number"
                  step="0.01"
                >
                  <template slot="prepend">NZD $</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="generateCustomizeString('limitedTimeDiscount')"
                prop="timed_special_price"
              >
                <el-input
                  v-model="merchandiseData.skus[0].timed_special_price"
                  type="number"
                  step="0.01"
                >
                  <template slot="prepend">NZD $</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="generateCustomizeString('productStock')" prop="stock">
                <el-input
                  v-model="merchandiseData.skus[0].stock"
                  :placeholder="generateCustomizeString('productStock')"
                  :disabled="merchandiseData.skus[0].is_seek_pos == 1"
                  style="width: 240px;"
                  type="number"
                  step="1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="generateCustomizeString('stockAlarm')" prop="stock_alarm">
                <el-input
                  v-model="merchandiseData.skus[0].stock_alarm"
                  :placeholder="generateCustomizeString('stockAlarm')"
                  value="0"
                  style="width: 240px;"
                  type="number"
                  step="1"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="isGoodFromPos">
              <el-form-item
                :label="generateCustomizeString('syncPosData')"
                prop="is_seek_pos"
              >
                <el-switch
                  v-model="merchandiseData.skus[0].is_seek_pos"
                >
                </el-switch>
              </el-form-item>
           </el-col>
            <el-col>
              <el-form-item :label="generateCustomizeString('productSku')">
                <el-input
                  v-model="merchandiseData.skus[0].bar_code"
                  :placeholder="generateCustomizeString('option')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="generateCustomizeString('productSKUWeight')">
                <el-input
                  v-model="merchandiseData.skus[0].weight"
                  :placeholder="generateCustomizeString('option')"
                >
                  <template slot="append">g</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item :label="generateCustomizeString('productProperty')">
                <el-button
                  @click="addProductProperty"
                  style="height: 40px; font-size: 14px;"
                  :disabled="isGoodFromPos"
                >{{generateCustomizeString('addProductProperty')}}</el-button>
              </el-form-item>
            </el-col>
          </div>
          <!-- 单个sku ends -->

          <!-- 多个Sku start -->
          <div v-else>
            <h4>{{generateCustomizeString('productProperty')}}</h4>
            <el-col class="productProperty">
              <div style="padding: 10px 20px; border-bottom: 1px solid #ddd;">
                <el-button
                  @click="addPropertyItem"
                  style="height: 40px; font-size: 14px;"
                  :disabled="this.dynamicProperty.length >= 2"
                >
                  {{generateCustomizeString('addPropertyItem')}}
                </el-button>
                <el-button
                  @click="removeProductProperty"
                  style="height: 40px; font-size: 14px;"
                >
                  {{generateCustomizeString('removePropertyItem')}}
                </el-button>
                <i
                  class="el-icon-circle-close"
                  style="float: right; font-size: 26px; margin-top: 5px; color: #888;"
                  @click="closeProductProperty"
                  v-if="this.dynamicProperty.length === 0"
                ></i>
              </div>
              <div
                style="height: auto;"
                v-for="(item, index) in dynamicProperty"
                :key="item.property"
              >
                <el-col style="padding-top: 20px;">
                  <el-form-item
                    :label="generateCustomizeString('productPropertyName')"
                    style="margin: 5px 0;"
                  >
                    <el-tag style="width: 150px; height: 40px; text-align: center; vertical-align: middle; font-size: 14px; padding: 4px;">
                      {{item.property}}
                    </el-tag>
                    <i class="el-icon-circle-close remove-property-item-icon" @click="removePropertyItem(index)"></i>
                  </el-form-item>
                </el-col>
                <el-col style="border-bottom: 1px solid #eee;  padding-bottom: 20px;">
                  <el-form-item
                    :label="generateCustomizeString('productPropertyValue')"
                    style="margin: 5px 0;"
                  >
                    <el-tag
                      v-for="(tag, tagIndex) in item.tags"
                      closable
                      :disable-transitions="false"
                      @close="tagHandleClose(tag, index, tagIndex)"
                      :key="tag"
                    >{{tag}}</el-tag>
                    <el-input
                      class="input-new-tag"
                      v-if="inputVisibles[index]"
                      v-model="inputValue[index]"
                      ref="saveTagInput"
                      size="small"
                      @keyup.enter.native="$event.target.blur"
                      @blur="handleInputConfirm(index)"
                    ></el-input>
                    <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showInput(index)"
                    >+ New</el-button>
                  </el-form-item>
                </el-col>
              </div>
            </el-col>
            <el-col style="margin-top: 30px" v-show="this.dynamicProperty.length !== 0">
              <el-table
                :data="tableData"
                :span-method="objectSpanMethod"
                border
                style="width: 90%; margin-left: 50px;"
              >
                <el-table-column
                  v-if="this.dynamicProperty[0]"
                  prop="tag"
                  :label="this.dynamicProperty[0].property"
                  align="center"
                  fixed="left"
                ></el-table-column>
                <el-table-column
                  v-if="this.dynamicProperty[1]"
                  prop="tag2"
                  :label="this.dynamicProperty[1].property"
                  align="center"
                  fixed="left"
                ></el-table-column>
                <el-table-column
                  :label="generateCustomizeString('priceSoldNz')"
                  prop="skuPrice"
                  width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.price" type="number" step="0.01">
                      <template slot="prepend">$</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="generateCustomizeString('limitedTimeDiscount')"
                  prop="timed_special_price"
                  width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input
                      size="small"
                      v-model="scope.row.timed_special_price"
                      :placeholder="generateCustomizeString('limitedTimeDiscount')"
                      type="number"
                      step="0.01"
                    >
                      <template slot="prepend">$</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="generateCustomizeString('skuWeight')"
                  prop="skuWeight"
                  width="130"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.weight" type="number" step="1">
                      <template slot="append">g</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="generateCustomizeString('productStock')"
                  prop="skuStock"
                  width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.stock" type="number" step="1"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="generateCustomizeString('stockAlarm')"
                  prop="skuStockAlarm"
                  width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.stock_alarm" type="number" step="1"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="generateCustomizeString('productSku')"
                  width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.bar_code"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="generateCustomizeString('merchandiseAlbum')"
                  align="center"
                  width="100"
                >
                  <template slot-scope="scope" style="text-align: center; vertical-align: middle;">
                    <div
                      style="width:95%; text-align: center;"
                      prop="skuImages"
                      v-show="scope.row.image_urls.length > 0"
                    >
                      <el-card :body-style="{ padding: '0px'}" style="text-align: center;">
                        <div class="sku-img">
                          <img
                            :src="scope.row.image_urls + '?imageView2/0/w/200/h/200/q/75|imageslim'"
                          />
                        </div>
                        <el-button
                          type="text"
                          class="button"
                          size="small"
                          style="width: 100%;"
                          @click="deleteSkuImgClick(scope.$index)"
                        >{{generateCustomizeString('delete')}}</el-button>
                      </el-card>
                    </div>
                    <el-upload
                      class="upload-demo"
                      :show-file-list="false"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :on-success="handleSkuImgSuccess.bind(this, scope.$index)"
                      :on-error="handleError"
                      :before-upload="beforeAvatarUpload"
                      action="https://upload-z2.qiniup.com"
                      :data="qiniuData"
                      style="text-align: center;"
                      v-show="scope.row.image_urls.length < 1"
                    >
                      <el-button
                        size="small"
                        type="primary"
                      >{{generateCustomizeString('clickUpload')}}</el-button>
                    </el-upload>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                size="small"
                v-if="this.tableData.length > 0"
                style="margin: 10px 0 0 50px;"
                @click="editAllPriceDialog = true"
              >{{generateCustomizeString('batchEditPrice')}}</el-button>
              <el-button
                size="small"
                v-if="this.tableData.length > 0"
                style="margin: 10px 0 0 20px;"
                @click="editAllStockDialog = true"
              >{{generateCustomizeString('batchEditStock')}}</el-button>
              <el-button
                size="small"
                v-if="this.tableData.length > 0"
                style="margin: 10px 0 0 20px;"
                @click="editAllStockAlarmDialog = true"
              >{{generateCustomizeString('batchSetStockAlert')}}</el-button>
              <el-button
                size="small"
                v-if="this.tableData.length > 0"
                style="margin: 10px 0 0 20px;"
                @click="editAllSpecialPriceDialog = true"
              >{{generateCustomizeString('batchEditLimitTime')}}</el-button>
            </el-col>
          </div>
          <!-- 多个Sku end -->
        </div>
        <!-- 商品规格 end -->
      </el-card>
      <el-card class="box-card" style="margin-top: 30px;">
        <!-- 商品相册 -->
        <div style="padding: 10px 0px 10px 0px;" class="clearfix">
          <h4>{{generateCustomizeString('merchandiseAlbum')}}</h4>
          <el-col style="padding-left: 50px;">
            <el-row>
              <el-col
                v-for="(item, index) in imageList"
                :key="index"
                style="width:16%; margin:0 .3%"
                prop="images"
              >
                <el-card :body-style="{ padding: '0px'}">
                  <div class="card-img">
                    <img :src="item + '?imageView2/0/w/350/h/350/q/75|imageslim'" />
                  </div>
                  <div style="padding: 14px;">
                    <div class="bottom clearfix">
                      <el-button
                        type="text"
                        class="button"
                        @click="topClick(index)"
                      >{{generateCustomizeString('topButton')}}</el-button>
                      <el-button
                        type="text"
                        class="button"
                        @click="delClick(index)"
                      >{{generateCustomizeString('deleteButton')}}</el-button>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <span style="color: red; float: left; padding-right: 10px; font-size: 16px">*</span>
            <el-upload
              action="https://upload-z2.qiniup.com"
              :drag="true"
              :on-success="handleAvatarSuccess"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
              :data="qiniuData"
              :show-file-list="true"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{generateCustomizeString('dragFiles')}}
                <em>{{generateCustomizeString('uploadFiles')}}</em>
              </div>
              <div class="el-upload__tip" slot="tip">{{generateCustomizeString('fileLimit')}}</div>
            </el-upload>
          </el-col>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 30px;">
        <!-- 商品描述 -->
        <div style="padding: 10px 0px 10px 0px;" class="clearfix">
          <h4>{{generateCustomizeString('merchandiseDetails')}}</h4>
          <tinymce
            :height="500"
            v-model="merchandiseData.desc"
            style="width: 90%; margin-left: 50px;"
          ></tinymce>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 30px;">
        <!-- 其它信息 -->
        <div style="padding: 10px 50px 0px 0px;" class="clearfix">
          <h4>{{generateCustomizeString('otherInformation')}}</h4>
          <el-form-item :label="generateCustomizeString('sortWeight')">
            <el-input
              v-model="merchandiseData.sort_by"
              :placeholder="generateCustomizeString('option')"
              type="number"
              step="1"
            ></el-input>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('selling')">
            <el-switch v-model="merchandiseData.is_sold"></el-switch>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('recommended')">
            <el-switch v-model="merchandiseData.is_promote"></el-switch>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('isCredit')">
            <el-switch v-model="merchandiseData.is_credit"></el-switch>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('isAgentVisible')">
            <el-switch v-model="merchandiseData.is_agent_visible"></el-switch>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('isAlone')">
            <el-switch v-model="merchandiseData.is_alone"></el-switch>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('onlyPickUp')">
            <el-switch v-model="merchandiseData.is_pick_up"></el-switch>&nbsp;
            <span
              class="only-pickup-warning"
            >*{{ generateCustomizeString('pickUpOnlyWarning')}}*</span>
          </el-form-item>
        </div>
      </el-card>

      <!-- 运营活动 -->
      <el-card class="box-card" style="margin-top: 30px;">
        <div class="clearfix">
          <h4>{{generateCustomizeString('promotion')}}</h4>
          <el-form-item :label="generateCustomizeString('freeShippingPromotion')">
            <el-radio-group v-model="shippingActivity" size="medium">
              <el-radio :label="false" border>{{generateCustomizeString('nonFreeShipping')}}</el-radio>
              <el-radio :label="true" border>{{generateCustomizeString('freeShipping')}}</el-radio>
              <el-radio
                :label="this.freeShippingOptions.value"
                border
                v-if="this.freeShippingOptions.label"
              >{{this.freeShippingOptions.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="generateCustomizeString('fullReductionPromotion')"
            v-if="this.fullReductionOptions.length > 0"
          >
            <el-select
              v-model="merchandiseData.full_reduction_activity_id"
              :placeholder="generateCustomizeString('fullReductionPromotion')"
              clearable
            >
              <el-option
                v-for="item in fullReductionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <span
              style="margin-left: 10px; color: red;"
              v-if="this.fullReductionOptions.length === 0"
            >{{generateCustomizeString('noFullReductionPromotion')}}</span>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('isThereAGiveaway')">
            <el-switch v-model="merchandiseData.is_gift"></el-switch>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('limitedTimeSpecialDeadline')">
            <el-date-picker
              v-model="merchandiseData.special_price_expired_at"
              type="datetime"
              :placeholder="generateCustomizeString('chooseDate')"
              style="width: 300px;"
            ></el-date-picker>
            <span
              style="margin-left: 10px; color: red;"
              v-if="isSpecialPriceExpiredAtBeforeNow"
            >{{generateCustomizeString('eventHasExpired')}}</span>
          </el-form-item>
          <el-form-item :label="generateCustomizeString('couponEnabled')">
            <el-switch v-model="merchandiseData.coupon_enabled"></el-switch>
          </el-form-item>
        </div>
      </el-card>
      <el-col>
        <el-form-item style="margin-left: -80px; margin-top: 30px;">
          <el-button
            v-if="isCreate"
            type="primary"
            @click="createGoods"
            plain
            style="width: 150px; height: 50px; font-size: 16px;"
          >{{generateCustomizeString('create')}}</el-button>
          <el-button
            v-else
            type="primary"
            @click="updateClick"
            plain
            style="width: 150px; height: 50px; font-size: 16px;"
          >{{generateCustomizeString('update')}}</el-button>
        </el-form-item>
      </el-col>
    </el-form>
    <el-button
      v-if="isCreate"
      round
      type="primary"
      icon="el-icon-edit-outline"
      style="width: 140px; position: fixed; right: 50px; bottom: 120px; z-index: 10000;"
      @click="createGoods"
    >{{generateCustomizeString('create')}}</el-button>
    <el-button
      v-else
      round
      type="primary"
      icon="el-icon-edit-outline"
      style="width: 140px; position: fixed; right: 50px; bottom: 120px; z-index: 10000;"
      @click="updateClick"
    >{{generateCustomizeString('update')}}</el-button>
    <el-button
      round
      plain
      type="primary"
      style="position: fixed; right: 50px; bottom: 50px; z-index: 10000;"
      icon="el-icon-arrow-left"
      @click="$router.go(-1)"
    >{{generateCustomizeString('return')}}</el-button>
    <!-- 各种 Dialog -->
    <el-dialog
      :title="generateCustomizeString('batchEditPrice')"
      :visible.sync="editAllPriceDialog"
      width="30%"
    >
      <el-input
        v-model="editAllPrice"
        :placeholder="generateCustomizeString('batchEditPrice')"
        @keyup.enter.native="editAllSkuPrice"
        onkeyup="value=value.replace(/[^\d.]/g,'')"
      >
        <template slot="prepend">NZD $</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAllPriceDialog = false">{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="editAllSkuPrice"
        >{{generateCustomizeString('deleteConfirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="generateCustomizeString('batchEditStock')"
      :visible.sync="editAllStockDialog"
      width="30%"
    >
      <el-input
        v-model="editAllStock"
        :placeholder="generateCustomizeString('batchEditStock')"
        @keyup.enter.native="editAllSkuStock"
        onkeyup="value=value.replace(/[^\d.]/g,'')"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAllStockDialog = false">{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="editAllSkuStock"
        >{{generateCustomizeString('deleteConfirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="generateCustomizeString('batchSetStockAlert')"
      :visible.sync="editAllStockAlarmDialog"
      width="30%"
    >
      <el-input
        v-model="editAllStockAlarm"
        :placeholder="generateCustomizeString('batchSetStockAlert')"
        @keyup.enter.native="editAllSkuStockAlarm"
        onkeyup="value=value.replace(/[^\d.]/g,'')"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="editAllStockAlarmDialog = false"
        >{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="editAllSkuStockAlarm"
        >{{generateCustomizeString('deleteConfirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="generateCustomizeString('batchEditLimitTime')"
      :visible.sync="editAllSpecialPriceDialog"
      width="30%"
    >
      <el-input
        v-model="editAllSpecialPrice"
        :placeholder="generateCustomizeString('batchEditLimitTime')"
        @keyup.enter.native="editAllSkuSpecialPrice"
        onkeyup="value=value.replace(/[^\d.]/g,'')"
      >
        <template slot="prepend">NZD $</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="editAllSpecialPriceDialog = false"
        >{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="editAllSkuSpecialPrice"
        >{{generateCustomizeString('deleteConfirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="generateCustomizeString('addPropertyItem')"
      :visible.sync="propertyDialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-input
        v-model="addProductPropertyName"
        :placeholder="generateCustomizeString('addPropertyItem')"
        @keyup.enter.native="addPropertyComfirm"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="propertyDialogVisible = false"
        >{{generateCustomizeString('deleteCancel')}}</el-button>
        <el-button
          type="primary"
          @click="addPropertyComfirm"
        >{{generateCustomizeString('deleteConfirm')}}</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import Tinymce from '@/components/Tinymce'
import request from '@/utils/request'
import { removeDuplicates, floatPriceCovertToIntPrice } from '@/utils/helper'
import dayjs from 'dayjs'

const defaultSingleSku = [
  {
    property: { property_default: 'property_item_default' },
    price: 0,
    timed_special_price: 0,
    weight: 0,
    stock: 0,
    is_seek_pos: 0,
    stock_alarm: 0,
    bar_code: 0,
    upload_image_keys: []
  }
]

const emptyUISkuData = {
  skuId: '',
  gap: 0,
  tag_key: '',
  tag: '',
  tag2_key: '',
  tag2: '',
  price: 0,
  timed_special_price: null,
  weight: 0,
  stock: 0,
  stock_alarm: 0,
  bar_code: '',
  upload_image_keys: [],
  image_urls: []
}

const emptyMerchandiseData = {
  id: '',
  product_name: '',
  product_subtitle: '',
  product_abbreviation: '',
  category_id: '',
  brand_id: '',
  warehouse_id: '',
  express_template_id: '',
  express_type: '',
  discount_plan_id: '',
  free_shipping_activity_id: '',
  full_reduction_activity_id: '',
  express_max: 0,
  weight: 0,
  width: 0,
  length: 0,
  height: 0,
  best_use_before_at: '',
  key_word: '',
  origin_sales_volume: 0,
  origin_views: 0,
  pos_platform: null,
  pos_unique_id: null,
  pos_platform_id: 0,
  skus: [
    {
      property: {},
      price: 0,
      timed_special_price: null,
      weight: 0,
      stock: 0,
      stock_alarm: 0,
      upload_image_keys: [],
      is_seek_pos: 0,
      bar_code: ''
    }
  ],
  price: 0,
  timed_special_price: null,
  stock: 0,
  stock_alarm: 0,
  sku: '',
  bar_code: '',
  is_sold: false,
  is_promote: false,
  is_credit: true,
  is_alone: false,
  is_free_shipping: false,
  is_gift: false,
  is_pick_up: false,
  is_agent_visible: false,
  coupon_enabled: false,
  sort_by: 0,
  desc: '',
  upload_image_keys: [],
  special_price_expired_at: ''
}

export default {
  name: 'MerchandiseDetail',
  components: {
    Tinymce
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mobileUrl: process.env.VUE_APP_MOBILE_URL + this.$store.state.shop.shop_domain_prefix,
      mobileNewUrl: '',
      pcUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : this.$store.state.shop.shop_pc_url,
      imageList: [], // 图片列表
      dialogImageUrl: '',
      dialogVisible: false,
      active: 0,
      singleSku: false,
      productProperty: false,
      propertyDialogVisible: false,
      productPropertyName: '',
      addProductPropertyName: '',
      dynamicProperty: [],
      keys: [],
      values: [],
      values2: [],
      inputVisibles: [false, false],
      inputValue: [],
      picDialogVisible: false,
      addPicVisible: true,
      imgListKey: [],
      skuImgKey: [],
      skuImgList: [],
      propertyName: 'property_default',
      editAllPriceDialog: false,
      editAllStockDialog: false,
      editAllStockAlarmDialog: false,
      editAllSpecialPriceDialog: false,
      editAllPrice: '',
      editAllStock: '',
      editAllStockAlarm: '',
      editAllSpecialPrice: '',
      merchandiseData: {},
      shippingActivity: false,
      categoriesOptions: [],
      brandOptions: [],
      freeShippingOptions: {},
      fullReductionOptions: [],
      warehouseOptions: [],
      expressTemplateOptions: [],
      expressTypeOptions: [],
      discountPlanOptions: [],
      selectedOptions2: [],
      fetchLoding: false,
      qiniuData: {
        token: ''
      },
      tableData: [],
      currentDate: new Date(),
      rules: {
        product_name: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        product_subtitle: [
          {
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        product_abbreviation: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        category_id: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        brand_id: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        warehouse_id: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        discount_plan_id: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        express_type: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        express_template_id: [
          {
            required: true,
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        best_use_before_at: [
          {
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ],
        key_word: [
          {
            message: this.generateCustomizeString('pleaseEnter'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    // 查询categories
    selectedCategories: {
      // getter
      get: function() {
        if (this.merchandiseData.category_id) {
          var i = this.categoriesOptions.length
          while (i--) {
            const obj = this.categoriesOptions[i]
            if (obj.value === this.merchandiseData.category_id) {
              return [obj.value]
            } else {
              if (obj.children) {
                const array = obj.children
                var j = array.length
                while (j--) {
                  const cobj = array[j]
                  if (cobj.value === this.merchandiseData.category_id) {
                    return [obj.value, cobj.value]
                  }
                }
              }
            }
          }
        }
        return []
      },
      // setter
      set: function(newValue) {
        this.merchandiseData.category_id = newValue[newValue.length - 1]
      }
    },
    displaySalesVolume: function() {
      return (
        parseInt(
          this.merchandiseData.origin_sales_volume
            ? this.merchandiseData.origin_sales_volume
            : 0
        ) + parseInt(this.merchandiseData.real_sales_volume)
      )
    },
    displayViews: function() {
      return (
        parseInt(
          this.merchandiseData.origin_views
            ? this.merchandiseData.origin_views
            : 0
        ) + parseInt(this.merchandiseData.real_views)
      )
    },
    isSpecialPriceExpiredAtBeforeNow: function() {
      if (this.merchandiseData.special_price_expired_at) {
        return dayjs(this.merchandiseData.special_price_expired_at).isBefore(
          dayjs()
        )
      } else {
        return false
      }
    },
    isGoodFromPos: function() {
      // check this good is from pos system
      return this.merchandiseData.pos_unique_id != null
    }
  },
  methods: {
    generateCustomizeString,

    editAllSkuPrice() {
      for (var i = 0; i < this.tableData.length; i++) {
        this.tableData[i].price = parseFloat(this.editAllPrice).toFixed(2)
      }
      this.editAllPriceDialog = false
    },
    editAllSkuStock() {
      for (var i = 0; i < this.tableData.length; i++) {
        this.tableData[i].stock = parseInt(this.editAllStock)
      }
      this.editAllStockDialog = false
    },
    editAllSkuStockAlarm() {
      for (var i = 0; i < this.tableData.length; i++) {
        this.tableData[i].stock_alarm = parseInt(this.editAllStockAlarm)
      }
      this.editAllStockAlarmDialog = false
    },
    editAllSkuSpecialPrice() {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.editAllSpecialPrice) {
          this.tableData[i].timed_special_price = parseFloat(
            this.editAllSpecialPrice
          ).toFixed(2)
        } else {
          this.tableData[i].timed_special_price = this.editAllSpecialPrice
        }
      }
      this.editAllSpecialPriceDialog = false
    },
    addProductProperty() {
      this.singleSku = false
    },
    addPropertyComfirm() {
      if (!this.addProductPropertyName) return
      const propertyItem = {
        property: this.addProductPropertyName,
        tags: []
      }
      this.dynamicProperty.push(propertyItem)
      this.propertyDialogVisible = false
      this.addProductPropertyName = ''
    },
    closeProductProperty() {
      this.singleSku = true
      this.dynamicProperty = []
      this.merchandiseData.skus = Object.assign({}, defaultSingleSku)
    },
    removePropertyItem(index) {
      // 如果属性只有一个的时候 构建使用单SKU
      if (this.dynamicProperty.length === 1) {
        this.merchandiseData.skus = Object.assign({}, defaultSingleSku)
        this.tableData = []
      } else {
        if (index === 0) {
          // 删除位于第一个位置的规格项目
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].skuId = ''
            this.tableData[i].tag_key = this.tableData[i].tag2_key
            this.tableData[i].tag = this.tableData[i].tag2
            this.tableData[i].tag2_key = 'none'
            this.tableData[i].tag2 = ''
            this.tableData[i].gap = 1
            this.tableData[i].price = 0
            this.tableData[i].timed_special_price = null
            this.tableData[i].weight = 0
            this.tableData[i].stock = 0
            this.tableData[i].stock_alarm = 0
            this.tableData[i].bar_code = ''
            this.tableData[i].upload_image_keys = []
            this.tableData[i].image_urls = []
          }
        } else if (index === 1) {
          // 删除位于第二个位置的规格项目
          for (var j = 0; j < this.tableData.length; j++) {
            this.tableData[j].skuId = ''
            this.tableData[j].tag2_key = 'none'
            this.tableData[j].tag2 = ''
            this.tableData[j].gap = 1
            this.tableData[j].price = 0
            this.tableData[j].timed_special_price = null
            this.tableData[j].weight = 0
            this.tableData[j].stock = 0
            this.tableData[j].stock_alarm = 0
            this.tableData[j].bar_code = ''
            this.tableData[j].upload_image_keys = []
            this.tableData[j].image_urls = []
          }
        }
        this.tableData = this.arrayUnique(this.tableData, 'tag')
      }
      this.dynamicProperty.splice(index, 1)
    },
    arrayUnique(arr, name) {
      var hash = {}
      return arr.reduce(function(item, next) {
        hash[next[name]] ? '' : (hash[next[name]] = true && item.push(next))
        return item
      }, [])
    },
    handleClose() {
      this.propertyDialogVisible = false
    },
    addPropertyItem() {
      this.propertyDialogVisible = true
    },
    removeProductProperty() {
      this.singleSku = true
      this.dynamicProperty = []
      this.merchandiseData.skus = Object.assign({}, defaultSingleSku)
      this.tableData = []
    },
    tagHandleClose(tag, index, tagIndex) {
      this.dynamicProperty[index].tags.splice(tagIndex, 1)
      if (index === 0) {
        if (this.dynamicProperty[0].tags.length === 0) {
          for (var m = 0; m < this.tableData.length; m++) {
            this.tableData[m].tag_key = this.tableData[m].tag2_key
            this.tableData[m].tag = this.tableData[m].tag2
            this.tableData[m].tag2_key = 'none'
            this.tableData[m].tag2 = ''
            this.tableData[m].gap = 1
          }
          this.dynamicProperty.splice(0, 1)
        } else {
          var tableTmp2 = []
          for (var j = 0; j < this.tableData.length; j++) {
            if (this.tableData[j].tag !== tag) {
              tableTmp2.push(this.tableData[j])
            }
          }
          this.tableData = tableTmp2
        }
      } else {
        if (this.dynamicProperty[1].tags.length === 0) {
          for (var n = 0; n < this.tableData.length; n++) {
            this.tableData[n].tag2_key = 'none'
            this.tableData[n].tag2 = ''
            this.tableData[n].gap = 1
          }
          this.dynamicProperty.splice(1, 1)
        } else {
          var tableTmp = []
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].tag2 !== tag) {
              tableTmp.push(this.tableData[i])
              this.tableData[i].gap = this.dynamicProperty[1].tags.length
            }
          }
          this.tableData = tableTmp
        }
      }
    },
    showInput(index) {
      this.inputVisibles.splice(index, 1, true)
    },
    handleInputConfirm(index) {
      const inputValue = this.inputValue[index]
      if (inputValue) {
        // 如果不是重复的值才增加规格值
        if (this.dynamicProperty[index].tags.indexOf(inputValue) === -1) {
          this.dynamicProperty[index].tags.push(inputValue.replace(/\s/g, ''))
        } else {
          return
        }
      } else {
        return
      }

      // 需要添加新的SKU值

      // 肯定会有第一个大规格
      const property1 = this.dynamicProperty[0]
      let property2 = {}
      if (this.dynamicProperty.length === 1) {
        property2 = { property: 'none', tags: [0] }
      } else {
        property2 = this.dynamicProperty[1]
      }

      var tag = ''
      var tag2 = ''

      // 需要先增加gap长度
      this.tableData.forEach(function(sku) {
        sku.gap = property2.tags.length
      })
      // index = 0 添加规格值到第一个大规格  index = 1 添加规格值到第二个大规格
      if (index === 0) {
        tag = inputValue
        for (var j = 0; j < property2.tags.length; j++) {
          tag2 = property2.tags[j]
          const sku = JSON.parse(JSON.stringify(emptyUISkuData))
          sku.gap = property2.tags.length
          sku.tag = tag
          sku.tag_key = property1.property
          sku.tag2 = tag2
          sku.tag2_key = property2.property
          this.tableData.push(sku)
        }
      } else if (index === 1) {
        tag2 = inputValue
        for (var i = 0; i < property1.tags.length; i++) {
          tag = property1.tags[i]
          const sku = JSON.parse(JSON.stringify(emptyUISkuData))
          sku.gap = property2.tags.length
          sku.tag = tag
          sku.tag_key = property1.property
          sku.tag2 = tag2
          sku.tag2_key = property2.property
          this.tableData.push(sku)
        }
        // 第一次加入第二个规格的时候需要去除之前None的空值
        for (var k = 0; k < this.tableData.length; k++) {
          if (this.tableData[k].tag2_key === 'none') {
            this.tableData.splice(k, 1)
          }
        }
      }
      // 排序一下
      this.tableData.sort(this.createComparionFun('tag'))
      this.inputVisibles.splice(index, 1, false)
      this.inputValue[index] = ''
    },
    createComparionFun(propertyName) {
      return function(object1, object2) {
        var value1 = object1[propertyName]
        var value2 = object2[propertyName]
        if (value1 > value2) {
          return -1
        } else if (value1 < value2) {
          return 1
        } else {
          return 0
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % row.gap === 0) {
          return [row.gap, 1]
        } else {
          return [0, 0]
        }
      }
    },
    picHandleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
      this.addPicVisible = false
    },
    handleSkuImgSuccess(index, res, file, fileList) {
      this.tableData[index].upload_image_keys.push(res.key)
      this.tableData[index].image_urls.push(
        'https://img.nzmai.com.cn/' + res.key
      )
      // this.$refs.imageSkuUpload.clearFiles()
      // this.skuImgKey.push(res.key)
      // this.skuImgList.push('https://img.nzmai.com.cn/' + res.key)
    },
    handleChange(file, fileList) {
      this.skuImgList = fileList.slice(-3)
    },
    topClick(index) {
      var key = this.imgListKey[index]
      this.imageList.unshift(this.imageList.splice(index, 1)[0])
      this.imgListKey.unshift(this.imgListKey.splice(index, 1)[0])
      var data = {
        qiniu_res_key: key,
        goods_spu_id: this.$route.params.goodsId
      }

      request({
        url: 'image/topping',
        method: 'patch',
        data
      })
        .then(response => {
          if (response.status === 0) {
            this.$message({
              message: this.generateCustomizeString('settingSuccessfully'),
              type: 'success'
            })
          } else {
            this.$message.error(this.generateCustomizeString('settingFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('settingFailed'))
        })
    },
    delClick(index) {
      this.imageList.splice(index, 1)
      this.imgListKey.splice(index, 1)
    },
    deleteSkuImgClick(index) {
      this.tableData[index].upload_image_keys.splice(0, 1)
      this.tableData[index].image_urls.splice(0, 1)
    },
    updateClick() {
      this.updateGoods()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handleChangeCategory(value) {
      this.merchandiseData.category_id = value[value.length - 1]
    },
    handleAvatarSuccess(res, file, fileList) {
      this.imageList.push('https://img.nzmai.com.cn/' + res.key)
      this.imgListKey.push(res.key)
    },
    handleError(res) {
      // 显示错误
      console.log(res)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG && !isPNG) {
        this.$message.error(this.generateCustomizeString('jpgpngonly'))
      }
      if (!isLt2M) {
        this.$message.error(this.generateCustomizeString('lessThan2MB'))
      }
      return (isJPG || isPNG) && isLt2M
    },
    handlePreview(file) {
      console.log(file)
    },
    fetchGoods() {
      const that = this
      return new Promise((resolve, reject) => {
        request({
          url: 'goods/' + this.$route.params.goodsId,
          method: 'get'
        })
          .then(res => {
            if (res.status === 0) {
              that.merchandiseData = res.data
              // 设置浏览量
              that.merchandiseData.real_sales_volume =
                res.data.sum_sales_volume - res.data.origin_sales_volume
              that.merchandiseData.real_views =
                res.data.sum_views - res.data.origin_views

              // 设置产品图片列表
              const getImgKey = []
              for (let m = 0; m < that.merchandiseData.images.length; m++) {
                getImgKey.push(that.merchandiseData.images[m].qiniu_res_key)
              }
              that.imgListKey = getImgKey

              // 设置一系列 boolean
              that.merchandiseData.is_sold = res.data['is_sold'] === 1
              that.merchandiseData.is_promote = res.data['is_promote'] === 1
              that.merchandiseData.is_credit = res.data['is_credit'] === 1
              that.merchandiseData.is_alone = res.data['is_alone'] === 1
              that.merchandiseData.is_pick_up = res.data['is_pick_up'] === 1
              that.merchandiseData.is_agent_visible =
                res.data['is_agent_visible'] === 1
              that.merchandiseData.is_free_shipping =
                res.data['is_free_shipping'] === 1
              that.merchandiseData.is_gift = res.data['is_gift'] === 1
              that.merchandiseData.coupon_enabled =
                res.data['coupon_enabled'] === 1

              // 转换时间
              if (that.merchandiseData.special_price_expired_at) {
                that.merchandiseData.special_price_expired_at = dayjs
                  .utc(
                    that.merchandiseData.special_price_expired_at,
                    'YYYY-MM-DD HH:mm:ss'
                  )
                  .local()
                  .toDate()
              } else {
                that.merchandiseData.special_price_expired_at = ''
              }

              // 设置活动
              if (that.merchandiseData.free_shipping_activity_id) {
                this.shippingActivity =
                  that.merchandiseData.free_shipping_activity_id
              } else {
                this.shippingActivity = that.merchandiseData.is_free_shipping
              }

              // 设置skus
              // 如果 skus 为空 初始化一个空白的skus
              const propertyName = 'property_default'
              const proertyValue = 'property_item_default'
              if (
                that.merchandiseData.skus.length === 0 ||
                !that.merchandiseData.skus
              ) {
                that.merchandiseData.skus = Object.assign({}, defaultSingleSku)
              }

              if (
                that.merchandiseData.skus.length === 1 &&
                that.merchandiseData.skus[0].property[propertyName] ===
                  proertyValue
              ) {
                that.singleSku = true
                that.merchandiseData.skus[0].is_seek_pos = that.merchandiseData.skus[0].is_seek_pos === 1
              } else {
                that.singleSku = false
              }

              // 格式化价格
              if (that.singleSku) {
                that.merchandiseData.skus[0].price =
                  that.merchandiseData.skus[0].price / 100
                that.merchandiseData.skus[0].timed_special_price =
                  that.merchandiseData.skus[0].timed_special_price / 100
              }

              // get dynamicPropertys from skus
              if (!that.merchandiseData.skus[0].property[propertyName]) {
                var keys = []
                for (var i = 0; i < that.merchandiseData.skus.length; i++) {
                  var tmp = Object.keys(that.merchandiseData.skus[i].property)
                  keys = tmp.concat(keys)
                }
                that.keys = removeDuplicates(keys)

                const values = []
                const values2 = []
                for (var j = 0; j < that.merchandiseData.skus.length; j++) {
                  values.push(
                    that.merchandiseData.skus[j].property[this.keys[0]]
                  )
                  if (that.keys[1]) {
                    values2.push(
                      that.merchandiseData.skus[j].property[this.keys[1]]
                    )
                  }
                }
                that.values = removeDuplicates(values)
                that.values2 = removeDuplicates(values2)
                var obj = { property: that.keys[0], tags: that.values }
                that.dynamicProperty.push(obj)
                if (that.keys[1]) {
                  that.dynamicProperty.push({
                    property: that.keys[1],
                    tags: that.values2
                  })
                }
              }

              // get tableData from skus
              const tableDataTmp = []
              if (!that.merchandiseData.skus[0].property[propertyName]) {
                let item2 = {}
                if (
                  that.dynamicProperty.length === 1 ||
                  !that.dynamicProperty[1].tags.length
                ) {
                  item2 = { property: 'none', tags: [0] }
                } else if (that.dynamicProperty.length === 2) {
                  item2 = this.dynamicProperty[1]
                }
                for (var s = 0; s < that.merchandiseData.skus.length; s++) {
                  var sobj = {}
                  sobj.gap = item2.tags.length
                  sobj.tag_key = this.dynamicProperty[0].property
                  sobj.tag2_key = item2.property
                  sobj.skuId = that.merchandiseData.skus[s].id
                  sobj.tag =
                    that.merchandiseData.skus[s].property[
                      this.dynamicProperty[0].property
                    ]
                  if (that.dynamicProperty[1]) {
                    sobj.tag2 =
                      that.merchandiseData.skus[s].property[
                        this.dynamicProperty[1].property
                      ]
                  }
                  sobj.price = that.merchandiseData.skus[s].price / 100
                  if (
                    that.merchandiseData.skus[s].timed_special_price !== null
                  ) {
                    sobj.timed_special_price =
                      that.merchandiseData.skus[s].timed_special_price / 100
                  }
                  sobj.weight = that.merchandiseData.skus[s].weight
                  sobj.stock = that.merchandiseData.skus[s].stock
                  sobj.stock_alarm = that.merchandiseData.skus[s].stock_alarm
                  sobj.bar_code = that.merchandiseData.skus[s].bar_code

                  var imageKeys = []
                  var imageUrl = []
                  if (that.merchandiseData.skus[s].images[0]) {
                    if (that.merchandiseData.skus[s].images[0].qiniu_res_key) {
                      imageKeys.push(
                        that.merchandiseData.skus[s].images[0].qiniu_res_key
                      )
                    }
                    if (that.merchandiseData.skus[s].images[0].image_url) {
                      imageUrl.push(
                        that.merchandiseData.skus[s].images[0].image_url
                      )
                    }
                  }
                  sobj.upload_image_keys = imageKeys
                  sobj.image_urls = imageUrl

                  tableDataTmp.push(sobj)
                }
              }
              that.tableData = tableDataTmp
              that.tableData.sort(this.createComparionFun('tag'))

              if (res.data.images.length) {
                for (const index in res.data.images) {
                  that.imageList.push(
                    // id: res.data.images[index].id,
                    res.data.images[index].image_url
                  )
                }
              }
              resolve()
            }
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        request({
          url: '/categories?page=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].name
              const sub = response.data[i].sub_categories
              for (let j = 0; j < response.data[i].sub_categories.length; j++) {
                var sobj = {}
                sobj.value = response.data[i].sub_categories[j].id
                sobj.label = response.data[i].sub_categories[j].name
                sub[j] = sobj
              }
              obj.children = sub
              data[i] = obj
            }
            this.categoriesOptions = data
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchBrand() {
      return new Promise((resolve, reject) => {
        request({
          url: '/brands?pages=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].brand_name
              data[i] = obj
            }
            this.brandOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchFreeShipping() {
      return new Promise((resolve, reject) => {
        request({
          url: 'activity/freeshipping/list',
          method: 'get'
        })
          .then(response => {
            if (response.data[0]) {
              this.freeShippingOptions.value = response.data[0].id
              this.freeShippingOptions.label = response.data[0].title
            }
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchFullReduction() {
      return new Promise((resolve, reject) => {
        request({
          url: 'activity/fullreduction/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              if (
                new Date(response.data[i].expired_at).getTime() >
                new Date().getTime()
              ) {
                obj.value = response.data[i].id
                obj.label = response.data[i].title
                data[i] = obj
              }
            }
            this.fullReductionOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchWarehouse() {
      return new Promise((resolve, reject) => {
        request({
          url: '/warehouses?pages=all',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].id
              obj.label = response.data[i].name
              data[i] = obj
            }
            this.warehouseOptions = data
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchDiscountPlan() {
      return new Promise((resolve, reject) => {
        request({
          url: 'discount/plan/list',
          method: 'get'
        })
          .then(response => {
            if (response.status === 0) {
              const data = response.data.map(plan => {
                plan.label = plan.name
                plan.value = plan.id
                return plan
              })
              this.discountPlanOptions = data
              resolve()
            } else if (response.status === 40005) {
              this.$message.error('No Disocunt Plan Found!')
              reject()
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchExpressTemplate() {
      return new Promise((resolve, reject) => {
        request({
          url: 'express/template/list',
          method: 'get'
        })
          .then(response => {
            if (response.status === 0) {
              const data = response.data.map(tpl => {
                tpl.label = tpl.name
                tpl.value = tpl.id
                return tpl
              })
              this.expressTemplateOptions = data
              resolve()
            } else if (response.status === 40005) {
              this.$message.error(this.generateCustomizeString('noPermission'))
              reject()
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchExpressType() {
      return new Promise((resolve, reject) => {
        request({
          url: 'express/type/list',
          method: 'get'
        })
          .then(response => {
            if (response.status === 0) {
              const data = response.data.map(type => {
                type.label = type.name
                type.value = type.type
                return type
              })
              this.expressTypeOptions = data
              resolve()
            } else if (response.status === 40005) {
              this.$message.error(this.generateCustomizeString('noPermission'))
              reject()
            }
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchUploadToken() {
      return new Promise((resolve, reject) => {
        request({
          url: '/upload-token',
          method: 'get'
        })
          .then(res => {
            this.qiniuData.token = res.data['token']
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getLocalTime(date, i) {
      // 参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
      if (typeof i !== 'number') return
      var d = new Date(date)
      // 得到1970年一月一日到现在的秒数
      var len = d.getTime()
      // 本地时间与GMT时间的时间偏移差
      var offset = d.getTimezoneOffset() * 60000
      // 得到现在的格林尼治时间
      var utcTime = len + offset
      return new Date(utcTime - 3600000 * i)
    },
    createGoods() {
      let special_price_expired_at = ''
      if (this.merchandiseData.special_price_expired_at) {
        special_price_expired_at = dayjs(
          this.merchandiseData.special_price_expired_at
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.shippingActivity === false || this.shippingActivity === true) {
        this.merchandiseData.is_free_shipping = this.shippingActivity
        this.merchandiseData.free_shipping_activity_id = ''
      } else {
        this.merchandiseData.free_shipping_activity_id = this.shippingActivity
        this.merchandiseData.is_free_shipping = false
      }

      // 保质期
      let best_use_before_at = null
      if (this.merchandiseData.best_use_before_at) {
        best_use_before_at = dayjs(
          this.merchandiseData.best_use_before_at,
          'YYYY-MM-DD'
        )
          .endOf('month')
          .utc()
          .format('YYYY-MM-DD')
      }

      var data = {
        product_name: this.merchandiseData.product_name,
        product_subtitle: this.merchandiseData.product_subtitle,
        product_abbreviation: this.merchandiseData.product_abbreviation,
        is_sold: this.merchandiseData.is_sold,
        is_promote: this.merchandiseData.is_promote,
        is_credit: this.merchandiseData.is_credit,
        is_alone: this.merchandiseData.is_alone,
        is_pick_up: this.merchandiseData.is_pick_up,
        is_agent_visible: this.merchandiseData.is_agent_visible,
        is_free_shipping: this.merchandiseData.is_free_shipping,
        is_gift: this.merchandiseData.is_gift,
        coupon_enabled: this.merchandiseData.coupon_enabled,
        sort_by: this.merchandiseData.sort_by,
        category_id: this.selectedCategories[
          this.selectedCategories.length - 1
        ],
        brand_id: this.merchandiseData.brand_id,
        desc: this.merchandiseData.desc,
        key_word: this.merchandiseData.key_word,
        warehouse_id: this.merchandiseData.warehouse_id,
        discount_plan_id: this.merchandiseData.discount_plan_id,
        weight: this.merchandiseData.weight,
        width: this.merchandiseData.width,
        length: this.merchandiseData.length,
        height: this.merchandiseData.height,
        express_type: this.merchandiseData.express_type,
        express_template_id: this.merchandiseData.express_template_id,
        best_use_before_at: best_use_before_at,
        origin_sales_volume: this.merchandiseData.origin_sales_volume,
        origin_views: this.merchandiseData.origin_views,
        upload_image_keys: this.imgListKey,
        free_shipping_activity_id: this.merchandiseData
          .free_shipping_activity_id,
        full_reduction_activity_id: this.merchandiseData
          .full_reduction_activity_id,
        special_price_expired_at: special_price_expired_at
      }

      if (this.tableData.length > 0) {
        data.skus = []
        for (var i = 0; i < this.tableData.length; i++) {
          const item = this.tableData[i]
          const sku = {}
          sku.property = {}
          const key = item.tag_key
          sku.property[key] = item.tag
          if (item.tag2) {
            const key2 = item.tag2_key
            sku.property[key2] = item.tag2
          }
          sku.price = floatPriceCovertToIntPrice(item.price)
          sku.timed_special_price = floatPriceCovertToIntPrice(
            item.timed_special_price
          )
          sku.weight = item.weight
          sku.stock = item.stock
          sku.stock_alarm = item.stock_alarm
          sku.bar_code = item.bar_code
          sku.upload_image_keys = item.upload_image_keys
          data.skus.push(sku)
        }
      } else {
        data.skus = [
          {
            property: { property_default: 'property_item_default' },
            price: floatPriceCovertToIntPrice(
              this.merchandiseData.skus[0].price
            ),
            timed_special_price: floatPriceCovertToIntPrice(
              this.merchandiseData.skus[0].timed_special_price
            ),
            weight: this.merchandiseData.skus[0].weight,
            stock: this.merchandiseData.skus[0].stock,
            stock_alarm: this.merchandiseData.skus[0].stock_alarm,
            bar_code: this.merchandiseData.skus[0].bar_code,
            upload_image_keys: this.imgListKey
          }
        ]
      }

      if (this.merchandiseData.product_name.length !== 0) {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            if (!isNaN(this.price)) {
              this.price = floatPriceCovertToIntPrice(this.price)
            }
            request({
              url: 'goods',
              method: 'post',
              data
            })
              .then(res => {
                if (res.status === 0) {
                  this.$message({
                    message: this.generateCustomizeString(
                      'createdSuccessfully'
                    ),
                    type: 'success'
                  })
                  this.$store.dispatch('delCurrentViews', {
                    view: this.$route,
                    $router: this.$router
                  })
                  this.$router.replace({ name: 'Management' })
                } else {
                  this.$message.error(
                    this.generateCustomizeString('createFailed')
                  )
                }
              })
              .catch(error => {
                console.log(error)
                this.$message.error(
                  this.generateCustomizeString('createFailed')
                )
              })
          } else {
            return false
          }
        })
      } else {
        return this.$message.error(this.generateCustomizeString('createFailed'))
      }
    },
    updateGoods() {
      let special_price_expired_at = ''
      if (this.merchandiseData.special_price_expired_at) {
        special_price_expired_at = dayjs(
          this.merchandiseData.special_price_expired_at
        )
          .utc()
          .format('YYYY-MM-DD HH:mm:ss')
      }

      if (this.shippingActivity === false || this.shippingActivity === true) {
        this.merchandiseData.is_free_shipping = this.shippingActivity
        this.merchandiseData.free_shipping_activity_id = ''
      } else {
        this.merchandiseData.free_shipping_activity_id = this.shippingActivity
        this.merchandiseData.is_free_shipping = false
      }

      let best_use_before_at = null
      if (this.merchandiseData.best_use_before_at) {
        best_use_before_at = dayjs(
          this.merchandiseData.best_use_before_at,
          'YYYY-MM-DD'
        )
          .endOf('month')
          .utc()
          .format('YYYY-MM-DD')
      }

      var data = {
        id: this.merchandiseData.id,
        product_name: this.merchandiseData.product_name,
        product_subtitle: this.merchandiseData.product_subtitle,
        product_abbreviation: this.merchandiseData.product_abbreviation,
        is_sold: this.merchandiseData.is_sold,
        is_promote: this.merchandiseData.is_promote,
        is_credit: this.merchandiseData.is_credit,
        is_alone: this.merchandiseData.is_alone,
        is_pick_up: this.merchandiseData.is_pick_up,
        is_agent_visible: this.merchandiseData.is_agent_visible,
        is_free_shipping: this.merchandiseData.is_free_shipping,
        is_gift: this.merchandiseData.is_gift,
        coupon_enabled: this.merchandiseData.coupon_enabled,
        sort_by: this.merchandiseData.sort_by,
        category_id: this.selectedCategories[
          this.selectedCategories.length - 1
        ],
        brand_id: this.merchandiseData.brand_id,
        desc: this.merchandiseData.desc,
        key_word: this.merchandiseData.key_word,
        warehouse_id: this.merchandiseData.warehouse_id,
        discount_plan_id: this.merchandiseData.discount_plan_id,
        weight: this.merchandiseData.weight,
        width: this.merchandiseData.width,
        length: this.merchandiseData.length,
        height: this.merchandiseData.height,
        express_type: this.merchandiseData.express_type,
        express_template_id: this.merchandiseData.express_template_id,
        best_use_before_at: best_use_before_at,
        origin_sales_volume: this.merchandiseData.origin_sales_volume,
        origin_views: this.merchandiseData.origin_views,
        upload_image_keys: this.imgListKey,
        free_shipping_activity_id: this.merchandiseData
          .free_shipping_activity_id,
        full_reduction_activity_id: this.merchandiseData
          .full_reduction_activity_id,
        special_price_expired_at: special_price_expired_at,
        skus: []
      }

      if (this.tableData.length > 0) {
        for (var i = 0; i < this.tableData.length; i++) {
          const item = this.tableData[i]
          const sku = {}
          if (item.skuId) {
            sku.id = item.skuId
          }
          sku.property = {}
          const key = item.tag_key
          sku.property[key] = item.tag
          if (item.tag2) {
            const key2 = item.tag2_key
            sku.property[key2] = item.tag2
          }
          sku.price = floatPriceCovertToIntPrice(item.price)
          if (item.timed_special_price) {
            sku.timed_special_price = floatPriceCovertToIntPrice(
              item.timed_special_price
            )
          }
          sku.weight = item.weight
          sku.stock = item.stock
          sku.stock_alarm = item.stock_alarm
          sku.bar_code = item.bar_code
          sku.upload_image_keys = item.upload_image_keys
          data.skus.push(sku)
        }
      } else {
        data.skus = JSON.parse(JSON.stringify(this.merchandiseData.skus))
        data.skus[0].price = floatPriceCovertToIntPrice(data.skus[0].price)
        data.skus[0].timed_special_price = floatPriceCovertToIntPrice(
          data.skus[0].timed_special_price
        )
        data.skus[0].upload_image_keys = JSON.parse(
          JSON.stringify(this.imgListKey)
        )
      }
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          request({
            url: 'goods/' + this.merchandiseData.id,
            method: 'put',
            data
          })
            .then(res => {
              if (res.status === 0) {
                this.$message({
                  message: this.generateCustomizeString('updateSuccessfully'),
                  type: 'success'
                })
                this.$router.replace({ name: 'Management' })
                // this.$router.go(-1)
              } else {
                this.$message.error(
                  this.generateCustomizeString('updateFailed')
                )
              }
            })
            .catch(error => {
              console.log(error)
              this.$message.error(this.generateCustomizeString('updateFailed'))
            })
        } else {
          this.$message.error(
            this.generateCustomizeString('incompleteIncomplete')
          )
          return false
        }
      })
    }
  },
  created() {
    this.fetchLoding = true
    if (process.env.VUE_APP_PC_URL == 'nzmai.com.cn') {
      this.mobileNewUrl =
        'https://' +
        this.$store.state.shop.shop_domain_prefix +
        window.location.href.substr(14, 13) +
        '/m'
    } else {
      this.mobileNewUrl =
        'http://' +
        this.$store.state.shop.shop_domain_prefix +
        '.miepay.xyz/m'
    }
    const shop_domain_prefix = this.$store.state.shop.shop_domain_prefix
    if (location.host.includes('ieshop.co.nz')) {
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + shop_domain_prefix
    }

    if (location.host.includes('ieshop.co.nz') && this.pcUrl.includes('nzmai.com.cn')) {
      this.pcUrl = 'https://' + shop_domain_prefix + '.ieshop.co.nz'
    }
    Promise.all([
      this.fetchCategories(),
      this.fetchWarehouse(),
      // 仓库数据
      this.fetchBrand(),
      this.fetchDiscountPlan(),
      // 折扣方案数据
      this.fetchExpressTemplate(),
      // 运费模版数据
      this.fetchExpressType(),
      this.fetchUploadToken(),
      this.fetchFreeShipping(),
      this.fetchFullReduction()
    ])
      .then(() => {
        if (!this.isCreate) {
          this.fetchGoods()
        } else {
          this.singleSku = true
          this.merchandiseData = Object.assign({}, emptyMerchandiseData)
        }
      })
      .catch(error => {
        console.warn(error)
      })
      .finally(() => {
        this.fetchLoding = false
      })
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.demo-userForm {
  padding: 50px 50px 0px 0px;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #ffffff;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  min-height: 60px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.title-label {
  display: inline-block;
  text-align: right;
  width: 160px;
}

.content-label {
  padding: 0px 0px 0px 20px;
}

.el-select {
  width: 130px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  padding-left: 6px;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}
.none-font{
  color: #8c939d;
}
.card-img {
  position: relative;
  height: 180px;
  overflow: hidden;
}
.card-img img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: auto;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.sku-img {
  height: auto;
}
.sku-img img {
  width: 100%;
  height: auto;
}
.productProperty {
  border: 1px solid #ddd;
  width: 90%;
  margin-left: 50px;
  margin-top: 0;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.demo-brandForm {
  padding: 10px 30px 0px 0px;
}
.only-pickup-warning {
  font-size: 12px;
  color: red;
}
.remove-property-item-icon {
  float: right;
  font-size: 26px;
  color: #ccc;
  margin-top: 5px;
  margin-right: 20px;
}
</style>
